import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { moreResults } from '../data/testimonials';
export function MoreResults() {
  return <section className="bg-navy-900 py-16 sm:py-20" aria-labelledby="results-title" data-id="element-152" data-mp="28f80yjn3pvsp">
      <div className="mx-auto max-w-5xl px-4" data-id="element-153" data-mp="28ddgf6fqs5p5">
        <h2 id="results-title" className="text-center text-3xl font-extrabold text-white sm:text-4xl" data-id="element-154" data-mp="2d6zun31k0hn2">
          What educators using this teacher ready say
        </h2>
        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-155" data-mp="2m6cwb9jfs1x8">
          {moreResults.map(([initials, name, place, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className={`flex flex-col rounded-xl border border-silver-400/20 bg-navy-800 p-6 shadow-lg shadow-black/20 ${index === 4 ? 'md:col-span-2' : ''}`} data-id="element-156" data-mp="2r70x2mxgvx4n" data-mpi={index}>
              <QuoteIcon className="h-6 w-6 text-silver-300" aria-hidden="true" data-id="element-157" data-mp="3impr5y22db9j" />
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-silver-200" data-id="element-158" data-mp="3ikwhe9w5maxb">“{quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-silver-400/15 pt-4" data-id="element-159" data-mp="38ojqfjrzub69">
                <span className="metal flex h-10 w-10 shrink-0 items-center justify-center rounded-lg text-sm font-extrabold text-navy-950" data-id="element-160" data-mp="a6w8pdo69ppu">
                  {initials}
                </span>
                <span data-id="element-161" data-mp="5607j7v7gho4">
                  <b className="block text-sm text-white" data-id="element-162" data-mp="871qfxtdpod">{name}</b>
                  <small className="text-xs text-silver-400" data-id="element-163" data-mp="at503do9j0s">{place}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}